import { Injectable } from "@angular/core";
import { HttpClient } from "src/app/shared/HttpClient";
import { ConfigService } from "../config/ConfigService";
import { ClientBannerDetails } from "./Model/clientBanner.model";
import { Http } from "@angular/http";

@Injectable({
    providedIn: "root",
})
export class ClientBannerService {
    bannerUrl: any;
     http: Http;
    baseUrl;

    constructor(private httpClient: HttpClient, config: ConfigService,http: Http) {
        this.httpClient = httpClient;
        this.http = http;
         this.baseUrl = config.get('apiUrl')
    }

    blockUI(blocked: boolean) {
        this.httpClient.callBlockUI(blocked);
    }

    getAllApplications() {
        return this.httpClient.get('api/banner/getAllApplications').map(response => {
            return response.json();
        });
    }

    getBanner(bannerId: string) {
        return this.httpClient.get(`api/banner/getBanner/${bannerId}`).map(response => {
            return response.json();
        });
    }

    saveBanner(banner: ClientBannerDetails): any {
        return this.httpClient.post('api/banner/saveBanner', banner).map((responsedata) => {
            let body = responsedata.json();
            return body || {};
        });
    }

    getActiveBannerOnApplication(applicationId:any)
    {
      return this.http.get(this.baseUrl + 'api/ApplicationInfo/getActiveBannerForApplication/'+applicationId)
         .map(response => {
            return response.json();
        });
    }

    getBannerGridData(searchData){
        return this.httpClient.post('api/banner/getBanners', JSON.stringify(searchData)).map(responsedata => {
           let body = responsedata.json();
           return body || {};
       });
   }

    validateBanner(banner: ClientBannerDetails): any {
        return this.httpClient.post('api/banner/validateBanner', banner).map((responsedata) => {
            let body = responsedata.json();
            return body || {};
        });
    }

    updateBanner(banner: ClientBannerDetails): any {
        return this.httpClient.post('api/banner/updateBanner', banner).map((responsedata) => {
            let body = responsedata.json();
            return body || {};
        });
    }
}